import {faAngleDown, faAngleUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {Component, Fragment} from "react";
import PrettyCheckbox from "../pretty_checkbox/PrettyCheckbox";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ShadowScrollbars from "../custom_scrollbars/ShadowScrollbars";
import * as PropTypes from "prop-types";
import Pagination from "../pagination/Pagination";
import Tools from "../../../Tools";
import "../../../assets/sass/components/datatable/react-bootstrap-table2.scss";
import {CircularSpinner} from "../spinner/Spinner";
import NoResultFound from "../feedback/NoResultFound";

const classNames = require('classnames');

class DataTableBase extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitState();
    }

    getInitState = () => ({
        rows: [],
        selectedRows: [],
        expandingRows: [],
        expandedRows: [],
        totalRows: 100,
        currentPage: 1,
        pageSize: 10,
        selectAll: false,
    });

    // TODO: Remove them later, I put them to move state from local to redux without any affects in other tables.
    get = (name) => this.props[name] ?? this.state[name];

    getState = () => ({
        rows: this.get('rows'),
        selectedRows: this.get('selectedRows'),
        expandingRows: this.get('expandingRows'),
        expandedRows: this.get('expandedRows'),

        totalRows: this.get('totalRows'),
        currentPage: this.get('currentPage'),
        pageSize: this.get('pageSize'),
        selectAll: this.get('selectAll'),
    });


    /**
     * Render datatable component.
     * @returns {React.ReactNode} The datatable component.
     */
    render = () => {
        return (
            <Fragment>
                {this.renderTable()}
                {this.renderPagination()}
            </Fragment>
        );
    };


    renderTable = () => {
        return (
            <div className={classNames("main-table", "datatable-base", this.extraClasses.table)}>
                {this.renderTableContent()}
            </div>
        )
    };
    /**
     * Render table component.
     * @returns {React.ReactNode} The table component.
     */
    renderTableContent = () => {
        const {loading, rows, error} = this.props;

        if (error) {
            return this.renderError(error);
        }

        const empty = rows?.length === 0;
        if (empty && !loading) {
            return this.renderEmpty();
        }

        return (
            <Fragment>
                {this.renderHeader()}
                <div className="datatable-base--body-wrapper">
                    {this.wrapBodyWithinScrollbar(this.renderBody())}
                    {loading && this.renderLoading()}
                </div>
            </Fragment>
        );

    };

    renderHeader = () => {
        const columns = this.getColumns();

        // Configure expanded row.
        const expandRowConfig = this.expandRowConfig();

        // Configure column of selecting rows.
        const selectRowConfig = this.selectRowConfig();


        return (
            <BootstrapTable
                keyField="id"
                wrapperClasses="header-only"
                expandRow={expandRowConfig.enable ? expandRowConfig : undefined}
                selectRow={selectRowConfig.enable ? selectRowConfig : undefined}
                bordered={false}
                data={[]}
                columns={columns}
            />
        )
    };

    renderBody = () => {
        const columns = this.getColumns();

        const {rows} = this.props;

        // For hide table columns.
        const blankColumns = columns.map(column => ({...column, text: '', sort: false}));

        // Configure expanded row.
        const expandRowConfig = this.expandRowConfig();

        // Configure column of selecting rows.
        const selectRowConfig = this.selectRowConfig();

        // Reformat and render rows of table.
        let renderedRows = rows.map(this.renderRow);

        return (
            <BootstrapTable
                keyField="id"
                rowClasses={this.setBodyClasses}
                headerClasses="hide"
                headerWrapperClasses={this.setBodyHeaderWrapperClasses()}
                wrapperClasses="table-responsive body-only"
                remote
                printable
                bordered={false}
                data={renderedRows}
                expandRow={expandRowConfig.enable ? expandRowConfig : undefined}
                selectRow={selectRowConfig.enable ? selectRowConfig : undefined}
                columns={blankColumns}
            />
        );
    };

    wrapBodyWithinScrollbar = (body) => {
        return (
            <ShadowScrollbars withPadding autoHide autoHideTimeout={1000} autoHideDuration={200} autoHeightMin={0} autoHeightMax={"100%"} thumbMinSize={30} universal={true}>
                {body}
            </ShadowScrollbars>
        );
    };

    /**
     * Renders row in the table.
     * @param rowData {object} The full data of the row.
     * @param rowIndex {integer} The index of the row.
     * @returns {React.ReactNode} The rendered row.
     */
    renderRow = (rowData, rowIndex) => {
        const columns = this.getColumns();
        return {
            ...rowData,
            ...columns.reduce((result, column, index) => {
                result[column.dataField] = this.renderCell(rowData, rowIndex, column, index);
                return result;
            }, {}),
        };
    };

    /**
     * Renders cell in specific row and columns.
     * @param rowData {object} The full data of row.
     * @param rowIndex {integer} The row index.
     * @param column {{dataField: string, renderer: function(object, string): React.ReactNode}} The column config.
     * @param columnIndex {integer} The column index.
     * @returns {React.ReactNode} The rendered cell.
     */
    renderCell = (rowData, rowIndex, column, columnIndex) => {
        const {renderer, dataField} = column;

        if (renderer)
            return renderer(rowData, dataField);
        else
            return rowData[dataField];
    };


    /**
     *
     * @param props
     * @returns {React.ReactNode}
     */
    renderExpandRowIcon = (props) => {
        const {expanded, rowKey, expandable} = props;
        let icon = expanded ? faAngleDown : faAngleUp;

        return (
            <FontAwesomeIcon size="lg" icon={icon}/>
        );
    };

    toggleRowColorSelected = (event, checked) => {
        const classList = event.target.closest('.table-row').classList;

        if (checked) {
            classList.add('selected');
        } else {
            classList.remove('selected');
        }

        return classList;
    };

    setBodyClasses = (row, rowIndex) => {
        const classes = "table-row";
        const selected = row.selected ? "selected" : "";
        return classNames(classes, selected);
    };

    setBodyHeaderWrapperClasses = () => {
        return '';
    };

    expandRowParentClassName = (isExpanded, row, rowIndex) => {
        const classes = "row-expanded remove-bottom-border";
        const selected = row.selected ? "selected" : "";
        return classNames(classes, selected);
    };

    onExpandRowEvent = (row, isExpand, rowIndex, e) => {
        const {onExpandRow} = this.props;
        if (typeof onExpandRow === 'function')
            onExpandRow(row, isExpand);
    };

    renderExpandedRow = (row, rowIndex) => {
        throw new Error("ExpandedRow renderer is not implemented");
    };

    /**
     * Render cell of selecting row.
     * @param rowState the state of selecting row.
     * @returns {React.ReactNode}
     */
    renderSelectRowIcon = (rowState) => {
        const {selectAll, selectedRows} = this.getState();

        const {enableSelect, disableSelectOverlayText} = this.props;
        const {rowIndex} = rowState;
        const row = this.getRow(rowIndex);

        const selected = selectedRows.map(player => player.id).indexOf(row.id) !== -1;

        if (enableSelect || selected) {
            return (
                <PrettyCheckbox checked={selected} disabled={selectAll} onCheckChange={(event) => this.handleRowSelect(rowState, row)}/>
            );
        } else {
            const overlay = (<Tooltip className="max-select-tooltip" id={"tooltip-row-" + rowIndex}>{disableSelectOverlayText}</Tooltip>);

            return (
                <OverlayTrigger placement="right" overlay={overlay}>
                    <div className="w-100 h-100">
                        <PrettyCheckbox checked={selected} disabled={true} onCheckChange={(event) => this.handleRowSelect(rowState, row)}/>
                    </div>
                </OverlayTrigger>
            );
        }
    };

    renderSelectHeaderIcon = (rowState) => {
        const {selectAll} = this.getState();

        return (
            <PrettyCheckbox checked={selectAll} onCheckChange={(event) => this.handleHeaderSelect(event, rowState)}/>
        );
    };

    renderPagination = () => {
        const {enable, defaultCurrentPage, pageSizeOptions, defaultOption} = this.paginationConfig();
        if (!enable) return undefined;

        const {currentPage, pageSize, total} = this.paginationProps();
        const handleSizePerPageChange = this.handleSizePerPageChange;
        const handlePageChange = this.handlePageChange;

        return (
            <Pagination
                currentPage={currentPage}
                pageSize={pageSize}
                totalSize={total ?? 0}
                defaultCurrentPage={defaultCurrentPage}
                pageSizeOptions={pageSizeOptions}
                defaultOption={defaultOption}
                onSizePerPageChange={handleSizePerPageChange}
                onPageChange={handlePageChange}/>
        );
    };

    renderLoading = (loading, progress) => {
        return <DataTableBase.LoadingOverlay/>
    };


    renderError = (error) => {
        return <DataTableBase.Error error={error}/>
    };

    renderEmpty = () => {
        return (
            <DataTableBase.NoResultsFound/>
        );
    };

    getRow = (index) => {
        const {rows} = this.props;
        return rows[index];
    };

    getColumns = () => {
        return this.columnsConfig().map((column) => {
            if (column.sort) {
                column.onSort = this.handleSort;
            }

            return {
                ...column,
                classes: this.columnClasses,
                headerClasses: this.columnHeaderClasses,
            }
        });
    };

    /**
     *
     * @returns {{renderer: DataTableBase.renderExpandedRow, onExpand: DataTableBase.onExpandRowEvent, enable: boolean, expandColumnRenderer: (function(*): *), parentClassName: (function(*, *, *): (*|string)), showExpandColumn: boolean, className: string, expandHeaderColumnRenderer: (function(): null), expandColumnPosition: string}}
     */
    expandRowConfig = () => {
        const {expandedRows} = this.getState();

        return {
            enable: true,
            showExpandColumn: true,
            className: 'remove-top-border expanded-table-row',
            parentClassName: this.expandRowParentClassName,
            expandColumnPosition: 'right',
            renderer: this.renderExpandedRow,
            expandColumnRenderer: this.renderExpandRowIcon,
            onExpand: this.onExpandRowEvent,
            expanded: expandedRows?.map(row => row.id) ?? [],
            expandHeaderColumnRenderer: () => null,
        };
    };

    selectRowConfig = () => {
        return {
            enable: true,
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            selectionRenderer: this.renderSelectRowIcon,
            selectionHeaderRenderer: this.renderSelectHeaderIcon,
        };
    };

    paginationConfig = () => {
        const options = [10, 20, 30, 50].map(item => {
            return {value: item, label: item}
        });

        const {pageSize} = this.getState();
        const defaultOption = pageSize ? {label: pageSize, value: pageSize} : options[0];

        return {
            enable: true,
            defaultCurrentPage: 1,
            pageSizeOptions: options,
            defaultOption: defaultOption,
        };
    };


    /**
     * Returns the table columns configurations.
     * @returns the columns configurations.
     */
    columnsConfig = () => {
        return this.props.columns;
    };

    columnClasses = (cell, row, rowIndex, colIndex) => {
        const columns = this.getColumns();
        return Tools.convertToDashCase(columns[colIndex].dataField) + '-cell';
    };

    columnHeaderClasses = (column, colIndex) => {
        const columns = this.getColumns();
        return Tools.convertToDashCase(columns[colIndex].dataField) + '-header-column';
    };


    /** Props **/

    /**
     * Returns props of pagination.
     * @returns {{total: *, pageSize: *, currentPage: *, filteredFrom: *}}
     * totalSize: The total size of rows in table,
     * pageSize: The size of each page,
     * currentPage: The number of current page
     */
    paginationProps = () => {
        const {currentPage, pageSize} = this.getState();
        const {total, filteredFrom} = this.props;

        return {
            currentPage: currentPage,
            pageSize: pageSize,
            total: total,
            filteredFrom: filteredFrom,
        };
    };


    /** Handlers **/
    handleHeaderSelect = (event, rowState) => {
        const {rows: _rows, selectAll} = this.getState();
        const {handleHeaderSelect} = this.props;

        const rows = _rows.map((row, index) => {
            row.selected = !selectAll;
            return row;
        });

        this.setState({
            selectAll: !selectAll,
            rows: rows
        });

        // outside handle if needed
        if (handleHeaderSelect) {
            handleHeaderSelect(event, rows);
        }
    };

    handleRowSelect = (rowState, row) => {
        // TODO: Remove all
        // color row when it is checked.
        // this.toggleRowColorSelected(event, !selected);

        // handle checked state
        // const {selectedRows: _selectedRows} = this.getState();
        //
        // const itemIndex = _selectedRows.indexOf(row);
        // if (itemIndex !== -1) {
        //     _selectedRows.splice(itemIndex, 1);
        // } else {
        //     _selectedRows.push(row);
        // }
        //
        // this.setState({
        //     selectAll: false,
        //     selectedRows: _selectedRows
        // });

        const {onRowSelect} = this.props;
        if (typeof onRowSelect === 'function')
            onRowSelect(row);
    };

    handleSizePerPageChange = (pageSize) => {
        const {onPageChange} = this.props;
        if (typeof onPageChange == 'function')
            onPageChange({pageSize: pageSize});
    };

    handlePageChange = (currentPage) => {
        const {onPageChange} = this.props;
        if (typeof onPageChange == 'function')
            onPageChange({currentPage: currentPage});
    };

    handleSort = (field, order) => {
        const {onSort} = this.props;
        if (onSort)
            onSort(field, order);
    };


    extraClasses = {
        table: '',
    };

    static defaultProps = {
        disableSelectOverlayText: "You can select Maximum 3 Players to Compare",
    };

    static propTypes = {
        rows: PropTypes.array.isRequired,
        // columns: PropTypes.array.isRequired,
        // enableSelect: PropTypes.bool.isRequired,
    };
}


DataTableBase.LoadingOverlay = (props) => {
    const loadingText = "Please wait. While we fetch the results";

    return (
        <div className="datatable-base-loading-overlay">
            <CircularSpinner show={true} className="datatable-base-loading-overlay--spinner"/>
            <div className="datatable-base-loading-overlay--text"> {loadingText} </div>
        </div>
    );
};

DataTableBase.NoResultsFound = (props) => {
    const details = "We can’t find any item matching your search.";
    return (
        <div className="datatable-base--feedback-wrapper">
            <NoResultFound details={details} {...props}/>
        </div>
    );
};

DataTableBase.Error = (props) => {
    const text = "OOPS! Something went wrong";
    const details = "" + props?.error?.message;

    return (
        <div className="datatable-base--feedback-wrapper">
            <NoResultFound text={text} details={details} {...props}/>
        </div>
    );
};


export default DataTableBase;
